import { useLogout } from 'react-easyrocket';
import { LogOutIcon } from './svg/LogOut';
import { useTranslation } from 'react-i18next';

export const LogOutButton = () => {
  const { mutateAsync: logout } = useLogout();
  const { t } = useTranslation();

  return (
    <button
      className="w-full flex justify-start items-center px-1 gap-2.5 group"
      onClick={() => logout({})}>
      <LogOutIcon className="group-hover:[&_path]:fill-text_active_sidebar w-6 h-6" />
      <p className="flex-1 text-left font-bold text-base text-text_primary_sidebar group-hover:text-text_active_sidebar">
        {t('profileMenuItems.logOut')}
      </p>
    </button>
  );
};
